
export interface ISetup
{
  id: number;
  prescriptionId: number;
  caseFileId: number;
  currentStep: number;
  prevPrescription: boolean;
  // Cache en memoria para evitar tener que esperar fetches al reinstanciar
  // CrudPrescriptionComponent (ej: al volver desde Confirmación a Prescripción).
  cachedPackageType?: number;
  cachedSetupType?: number;
}

export class Setup
{
  public id: number;
  public prescriptionId: number;
  public caseFileId: number;
  public currentStep: number;
  public prevPrescription: boolean;
  public cachedPackageType?: number;
  public cachedSetupType?: number;
  constructor() { }
}
